import { LocaleDropdown } from './LocaleDropdown';
export default LocaleDropdown;
